import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ChatModalService {
  private readonly _isOpen$ = new BehaviorSubject<boolean>(false);
  readonly isOpen$ = this._isOpen$.asObservable();

  open(): void { this._isOpen$.next(true); }
  close(): void { this._isOpen$.next(false); }
  toggle(): void { this._isOpen$.next(!this._isOpen$.value); }
}
